module.exports = __webpack_public_path__ + "img/nft.e4752356.png";